var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#18191F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.718 19V12.6243H14.8689L15.1886 10.128H12.718V8.53802C12.718 7.81769 12.9187 7.3245 13.9525 7.3245H15.2625V5.09892C14.6251 5.03062 13.9844 4.99764 13.3434 5.00013C11.4422 5.00013 10.1369 6.16076 10.1369 8.29143V10.1234H8V12.6197H10.1416V19H12.718Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFb);
export default __webpack_public_path__ + "static/media/footer_fb.bae5012e48224bc2bfea7d193178abea.svg";
export { ForwardRef as ReactComponent };